import request from './request';

//获取单位预约信息
export function getOrderList(hospId, idCard) {
    return request.get('/api/Order/UnitOrderRecord', {
        params: {
            hospid: hospId,
            sfzh: idCard,
        }
    });
}

//获取单位预约信息
export function getAppointments(hospId) {
    return request.get('/api/company/appointments', {
        params: {
            hospid: hospId
        }
    });
}

//获取单位预约信息
export function getSchedule(appointment) {
    return request.post('/api/company/GetSchedules', appointment);
}

export function saveAppointment(appointment) {
    return request.post('/api/company/SaveCompanyAppointment', appointment);
}

export function cancelAppointment(appointment) {
    return request.post('/api/company/CancelCompanyAppointment', appointment);
}

// 更新单位预约信息
export function updateAppointment(hospId, tjbh, action, date) {
    return request.post('/api/Order/UnitOrder', {
        "hospid": hospId,
        "tjbh": tjbh,
        "appdate": date,
        "apptime": "",
        "action": action,
    });
}

// 获取单位团检申请
export function getRequirement(hospId) {
    return request.get('/api/company/requirement', {
        params: {
            hospid: hospId
        }
    });
}

// 保存单位团检申请
export function saveRequirement(reqData) {
    return request.post('/api/company/saveRequirement', reqData);
}

// 获取单位分组明细
export function getGroupDetails(groupId) {
    return request.get('/api/company/groupDetails', {
        params: {
            groupId
        }
    });
}

/**
 * 根据分组ID获取对应的加项组类信息（国宾需求）
 * @param {*} groupId 分组ID
 * @returns 加项组类集合
 */
export function getComboCategories(groupId) {
    return request.get('/api/company/GetCompanyComboCategories', {
        params: {
            groupId
        }
    });
}

/**
 * 根据预约号获取对应的分组列表，用于更换分组
 * @param {*} apptId 
 * @returns 分组集合
 */
export function getGroups(apptId) {
    return request.get('/api/company/GetCompanyGroups', {
        params: {
            apptId
        }
    });
}